<svg data-test-id="loader-spinner"  class="spinner" width="70px" height="70px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
  <circle  id="circle" class="path" fill="transparent" stroke-width="6" cx="33" cy="33" r="30" />
  <linearGradient id="gradient">
    <stop offset="50%" stop-color="#0077ad" stop-opacity="1" />
    <stop offset="65%" stop-color="#0077ad" stop-opacity=".5" />
    <stop offset="100%" stop-color="#0077ad" stop-opacity="0" />
  </linearGradient>
</svg>
